import {
    GET_DEVICE_CACHE_REQUEST,
    GET_DEVICE_CACHE_SUCCESS,
    GET_DEVICE_CACHE_ERROR,
    SET_DEVICE_CACHE_REQUEST,
    SET_DEVICE_CACHE_SUCCESS,
    SET_DEVICE_CACHE_ERROR,
} from 'constants/ActionTypes';

export default function (state = {}, action) {
    switch (action.type) {
        case GET_DEVICE_CACHE_REQUEST:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case GET_DEVICE_CACHE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                current: action.payload,
            };
        case GET_DEVICE_CACHE_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        case SET_DEVICE_CACHE_REQUEST:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case SET_DEVICE_CACHE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                current: action.payload,
            };
        case SET_DEVICE_CACHE_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
}
